import { Box } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { IFeature } from '../data/types';
import FeatureCard from './FeatureCard';
import SectionHeading from './SectionHeading';

interface SpotlightSectionProps {
    features: IFeature[];
    onOpen: (feature: IFeature) => void;
}

const SpotlightSection = ({ features, onOpen }: SpotlightSectionProps) => {
    if (!features.length) return null;

    return (
        <Box component="section" dir="rtl">
            <SectionHeading
                title="חדש עכשיו"
                subtitle="היכולות שהוספנו לאחרונה — לחיצה על קוביה פותחת הדגמה, פירוט מלא ואיך מפעילים."
                icon={<AutoAwesome sx={{ color: '#0aa6a6', fontSize: 32 }} />}
            />
            <Box
                dir="rtl"
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 3,
                    '& > *': {
                        boxSizing: 'border-box',
                        flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' },
                        maxWidth: { xs: '100%', md: 'calc(50% - 12px)' }
                    }
                }}
            >
                {features.map((feature) => (
                    <Box key={feature.id}>
                        <FeatureCard feature={feature} variant="spotlight" onOpen={onOpen} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default SpotlightSection;
